<script setup>
import { computed } from 'vue';
const { n } = useI18n();

const props = defineProps({
  selectedPrice: {
    type: Object,
    required: true,
  },
  optionPrice: {
    type: Object,
    required: true,
  },
});

const priceDifference = computed(() => {
  if (!props.selectedPrice || !props.optionPrice) {
    return null;
  }

  const selectedPriceValue = parseFloat(props.selectedPrice.amount);
  const optionPriceValue = parseFloat(props.optionPrice.amount);

  if (!Number.isFinite(selectedPriceValue) || !Number.isFinite(optionPriceValue)) {
    return null;
  }

  const difference = optionPriceValue - selectedPriceValue;

  if (difference <= 0) {
    return null;
  }

  return {
    amount: difference,
    currencyCode: props.selectedPrice.currencyCode,
  };
});
</script>

<template>
  <span v-if="priceDifference">
    <slot></slot>
    {{
      n(priceDifference.amount, {
        style: 'currency',
        currency: priceDifference.currencyCode,
      })
    }}
  </span>
</template>
